import React from 'react';

const stats = [
  { label: 'Operating Model', value: 'Fractional + embedded' },
  { label: 'Focus',           value: 'Modernization & AI'   },
  { label: 'Approach',        value: 'Strategy to shipped'  },
];

const pillars = [
  {
    title: 'Hands-on execution',
    body: 'We sit with your teams, remove blockers, and ensure recommendations turn into results. No slideware-only engagements.',
    dot: 'bg-em',
    dotBorder: 'border-em-border',
  },
  {
    title: 'Independent & objective',
    body: 'Unbiased guidance with no vendor quotas or platform allegiances — only what serves your business goals.',
    dot: 'bg-teal-dark',
    dotBorder: 'border-teal-border',
  },
  {
    title: 'Proven results',
    body: 'From board-level briefings to program recovery, we balance strategic vision with the operator mindset needed to deliver.',
    dot: 'bg-em',
    dotBorder: 'border-em-border',
  },
];

const About: React.FC = () => {
  return (
    <section id="about" className="bg-teal-light py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16">

          {/* Left — narrative */}
          <div className="lg:col-span-3 space-y-6">
            <div className="space-y-3">
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-white border border-teal-border text-xs text-teal-deeper font-semibold">
                Experience That Delivers
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 leading-tight">
                Senior leadership without<br />the full-time overhead.
              </h2>
            </div>

            <p className="text-slate-500 leading-relaxed">
              With 25+ years leading technology and operations across Fortune 500 and high-growth companies, Nova Terra Consulting brings calm, decisive leadership to mid-market teams that need to move faster without creating chaos.
            </p>
            <p className="text-slate-500 leading-relaxed">
              We help organizations navigate tough technology decisions, modernize legacy systems, and implement AI and automation that actually ship. Expect candor, clear governance, and sleeves-rolled-up delivery.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-teal-border border border-teal-border rounded-2xl overflow-hidden shadow-card bg-white">
              {stats.map((stat) => (
                <div key={stat.label} className="p-5">
                  <p className="text-[10px] text-teal-deeper font-semibold uppercase tracking-widest mb-1">{stat.label}</p>
                  <p className="text-sm font-bold text-slate-900">{stat.value}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — credibility pillars */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-3xl border border-teal-border shadow-card overflow-hidden">
              <div className="h-0.5 w-full gradient-em" />

              {pillars.map((pillar, i) => (
                <div
                  key={pillar.title}
                  className={`group p-6 hover:bg-em-light/40 transition-colors duration-200 ${i < pillars.length - 1 ? 'border-b border-slate-50' : ''}`}
                >
                  <div className="flex items-start gap-3">
                    <div className={`mt-1 h-5 w-5 rounded-full bg-white border-2 ${pillar.dotBorder} flex items-center justify-center flex-shrink-0`}>
                      <div className={`h-2 w-2 rounded-full ${pillar.dot}`} />
                    </div>
                    <div>
                      <h3 className="text-sm font-bold text-slate-900 mb-1.5">{pillar.title}</h3>
                      <p className="text-sm text-slate-500 leading-relaxed">{pillar.body}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;
